export const createWrapper =
  <T extends object, K>(wrapper: (resource: Resource<T>) => K) =>
  (resource: Resource<T>): T & K =>
    Object.assign(resource ? resource : ({} as T), wrapper(resource));

export type Resource<T> = T | null | undefined;
